export enum DebugSectionNames {
    QUOTE_STATE = 'Quote State',
    VEHICLE_STATE = 'Vehicle State',
    HOME_CONTENTS_STATE = 'Home Contents State',
    PERSONAL_DETAILS_STATE = 'Personal Details State',
    POLICY_HOLDER_STATE = 'Policy Holder State',
    HOUSEHOLD_MEMBERS_STATE = 'Household Members State',
    PAYMENT_DETAILS_STATE = 'Payment Details State',
    DATA_LAYER_STATE = 'Datalayer',
    POLICY_STATE = 'Policy State',
    STATIC_DATA_STATE = 'Static Data State',
    CMS_STATE = 'CMS State',
}
